import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-auto"
}
const _hoisted_2 = { class: "card py-2 px-2" }
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "d-flex justify-content-end" }
const _hoisted_13 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_text_editor = _resolveComponent("text-editor")!
  const _component_modal = _resolveComponent("modal")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[14] || (_cache[14] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Welcome Messages"),
      _createElementVNode("p", null, [
        _createElementVNode("small", null, "Set welcome messages for each partner's landing page.")
      ])
    ], -1)),
    (!_ctx.loading && !_ctx.has_error && _ctx.partners)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _cache[11] || (_cache[11] = _createElementVNode("thead", { class: "thead-dark" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "header-row py-2 px-2" }, "Partner Name"),
                  _createElementVNode("th", { class: "header-row py-2" }, "Partner Slug"),
                  _createElementVNode("th", { class: "header-row py-2" }, "Welcome Message")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: partner.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(partner.short_name), 1),
                    _createElementVNode("td", null, _toDisplayString(partner.slug), 1),
                    _createElementVNode("td", null, [
                      (partner.welcome_header)
                        ? (_openBlock(), _createElementBlock("h2", {
                            key: 0,
                            innerHTML: partner.welcome_header
                          }, null, 8, _hoisted_4))
                        : (_openBlock(), _createElementBlock("h2", _hoisted_5, _cache[8] || (_cache[8] = [
                            _createTextVNode("Welcome To Your"),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode("Online Standardized Patient Experience")
                          ]))),
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: ($event: any) => (_ctx.editHeader(i))
                      }, "Edit Welcome Header", 8, _hoisted_6),
                      _cache[9] || (_cache[9] = _createElementVNode("p", null, " ", -1)),
                      _createElementVNode("div", {
                        innerHTML: partner.welcome_message
                      }, null, 8, _hoisted_7),
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: ($event: any) => (_ctx.editMessage(i))
                      }, "Edit Welcome Message", 8, _hoisted_8),
                      _cache[10] || (_cache[10] = _createElementVNode("p", null, " ", -1))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : (!_ctx.loading && _ctx.has_error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[12] || (_cache[12] = _createElementVNode("h3", null, "Error", -1)),
            _createElementVNode("p", { innerHTML: _ctx.error_msg }, null, 8, _hoisted_10)
          ]))
        : (!_ctx.loading && !_ctx.has_error && !_ctx.partners)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[13] || (_cache[13] = [
              _createElementVNode("p", null, "No partners in system", -1)
            ])))
          : _createCommentVNode("", true),
    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_modal, {
      modelValue: _ctx.display_edit_form,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.display_edit_form) = $event))
    }, {
      header: _withCtx(() => [
        _createTextVNode("Update Welcome Message for " + _toDisplayString(_ctx.edit_partner_name), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Loading, {
          active: _ctx.loading,
          "is-full-page": false
        }, null, 8, ["active"]),
        _createVNode(_component_text_editor, {
          modelValue: _ctx.welcome_message,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.welcome_message) = $event))
        }, null, 8, ["modelValue"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveWelcomeMessage()))
          }, "Save"),
          _createElementVNode("button", {
            class: "btn btn-secondary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.display_edit_form = false)),
            type: "button"
          }, "Cancel")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.display_edit_header_form,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.display_edit_header_form) = $event))
    }, {
      header: _withCtx(() => [
        _createTextVNode("Update Welcome Header for " + _toDisplayString(_ctx.edit_partner.short_name), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_loading, {
          active: _ctx.loading,
          "is-full-page": false
        }, null, 8, ["active"]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          maxlength: "255",
          class: "w-100",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.welcome_header) = $event))
        }, null, 512), [
          [_vModelText, _ctx.welcome_header]
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveWelcomeHeader()))
          }, "Save"),
          _createElementVNode("button", {
            class: "btn btn-secondary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.display_edit_header_form = false)),
            type: "button"
          }, "Cancel")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}